import { StyleRules } from '@material-ui/core/styles';
import { ListClassKey } from '@material-ui/core/List';

import { core as theme } from '../styles/core';

export const MuiList: Partial<StyleRules<ListClassKey>> = {
  root: {
    backgroundColor: theme.palette.common.white,
  },
  padding: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
};
